<ng-container *ngIf="show$ | async">
  <button
    mat-icon-button
    (click)="setOpen(true)"
    (mouseover)="onMouseOver()"
    i18n-matTooltip="@@Tooltip.SearchForProducts"
    matTooltip="Search for Products"
    matTooltipClass="accent"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    class="search-button"
  >
    <fa-icon icon="search"></fa-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayPositions]="[
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' }
    ]"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayPanelClass]="['fullwidth']"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open"
    (overlayOutsideClick)="outsideClick($event)"
    (overlayKeydown)="overlayKeyDown($event)"
  >
    <x-search-input (closeOverlay)="setOpen(false)"></x-search-input>
  </ng-template>
</ng-container>
